module.exports = __webpack_public_path__ + "static/media/Политика_в_отношении_обработки_персональных.d5e1c5ce.pdf";